/**
 * @generated SignedSource<<3359e7818ccf8abc5d6e61c7e0a89617>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StemBalanceResponse",
    "kind": "LinkedField",
    "name": "getBalanceByLabel",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "balance",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "topGetBalanceByLabelQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "topGetBalanceByLabelQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "2d941c577dab2f9365cd584bada85eb8",
    "id": null,
    "metadata": {},
    "name": "topGetBalanceByLabelQuery",
    "operationKind": "query",
    "text": "query topGetBalanceByLabelQuery {\n  getBalanceByLabel {\n    balance\n  }\n}\n"
  }
};
})();

node.hash = "6e8822085e1fa20f5c404485e81469e9";

module.exports = node;
